<template>
  <div>
    <div class="holidy_pz_box">
      <div class="headerSearch">
        <el-form
          class="t_search_form"
          label-position="left"
          style="width: 90%; margin-left: auto; margin-right: auto"
          label-width="90px"
        >
          <el-form-item label="配置类型：" label-width="85px">
            <el-select v-model="search.type" filterable placeholder="请选择">
              <el-option
                v-for="(item, index) in typeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="日期:">
            <el-date-picker
              v-model="search.cdate"
              type="date"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              clearable
            />
          </el-form-item>
          <el-button
            v-preventReClick
            class="sousuoButton"
            icon="el-icon-search"
            round
            size="small"
            type="primary"
            @click="searchbtn"
          >搜索</el-button>
          <el-button
            v-preventReClick
            size="small"
            icon="el-icon-refresh-right"
            round
            @click="reset"
          >重置</el-button>
        </el-form>
      </div>
      <div class="t_con_w" style="padding-top: 40px; padding-bottom: 57px">
        <div style="width: 90%; margin-left: auto; margin-right: auto">
          <div
            style="
              background-color: #f4f4f4;
              padding: 12px 10px;
              border: 1px solid #f4f4f4;
            "
          >
            <el-button
              v-preventReClick
              icon="el-icon-plus"
              type="primary"
              size="mini"
              style="background-color: #4170ff; border: none; color: white"
              @click="addorEdit('0')"
            >新增</el-button>
            <el-button
                v-preventReClick
                icon="el-icon-refresh"
                type="warning"
                size="mini"
                style="border: none; color: white"
                @click="refreshCache()"
            >刷新缓存</el-button>
          </div>
          <el-table
            :data="tableData"
            :header-cell-style="{ background: '#f4f4f4', color: '#909399' }"
            border
            style="
              width: 100%;
              border-left: 1px solid #f4f4f4;
              border-right: 1px solid #f4f4f4;
            "
          >
            <el-table-column type="selection" align="center" width="55" />
            <el-table-column
              align="center"
              prop="typeLabel"
              :show-overflow-tooltip="true"
              label="配置类型"
            />
            <el-table-column
              align="center"
              prop="cdate"
              :show-overflow-tooltip="true"
              label="配置日期"
            />
            <el-table-column
              align="center"
              prop="xzqhLabel"
              :show-overflow-tooltip="true"
              label="所属区划"
            />
            <el-table-column
              align="center"
              width="200px"
              label="操作"
            >
              <template slot-scope="scope">
                <el-button
                  v-preventReClick
                  size="mini"
                  icon="el-icon-edit"
                  style="background-color: #4170ff; border: none; color: white"
                  @click="addorEdit('1',scope.row)"
                >编辑</el-button>
                <el-button
                  v-preventReClick
                  size="mini"
                  icon="el-icon-delete"
                  style="background-color: #ff5721; border: none; color: white"
                  @click="delSaveItem(scope.row.id)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager,next,jumper,total,sizes"
            :page-sizes="[10, 20, 30, 40]"
            :total="total"
            :page-size="1"
            class="el-page"
            @current-change="currentChange"
            @size-change="sizeChange"
          />
        </div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="digshow"
      width="1200px"
      @close="dialogClose"
    >
      <div class="t_dig" v-loading = "loading">
        <div style="font-weight: bold; font-size: 20px; text-align: center">
          {{ tetle }}
        </div>
        <div style="background-color: white">
          <div class="t_rk">
            <el-form
              ref="ruleForm"
              label-position="right"
              :rules="rules"
              :model="holidyForm"
              style="
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
              "
              label-width="130px"
            >
              <el-form-item
                label="配置类型："
                prop="type"
                style="margin-right: 0; width: 100%"
              >
                <el-select v-model="holidyForm.type" placeholder="请选择" style="width: 100%">
                  <el-option
                    v-for="(item, index) in typeList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item
                label="配置日期："
                prop="cdate"
                style="margin-right: 0; width: 100%"
              >
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  v-model="holidyForm.cdate"
                  style="width: 100%"
                  type="date"
                  placeholder="选择日期"
                />
              </el-form-item>
              <el-form-item label="行政区划：" prop="xzqhId" style="margin-right: 0; width: 100%">
                <el-cascader
                  ref="xzqhCascader"
                  v-model="xzqhId"
                  style="width: 100%"
                  :props="{ checkStrictly: true }"
                  :options="xzqhTree"
                  @change="jgChange"
                />
              </el-form-item>
            </el-form>
            <div
              style="
                width: 498px;
                margin-left: auto;
                margin-right: auto;
                margin-top: 40px;
                margin-bottom: 45px;
                display: flex;
                justify-content: space-around;
              "
            >
              <el-button
                v-preventReClick
                type="primary"
                style="
                  width: 148px;
                  height: 60px;
                  border: none;
                "
                @click="saveItem()"
              >保存</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {getHolidyList, addSave, editSave, deleteSave, refreshCache} from "@/assets/js/holidyPz";
  import { xzqhTree} from '@/assets/js/bmgl.js';
export default {
  name: 'HolidyPz',
  data() {
    const gajgjiaoyan = (rule, value, callback) => {
      if (this.xzqhId.length == 0) {
        return callback(new Error('请选择行政区划'))
      } else {
        callback()
      }
    }
    return {
      digshow:false,
      loading: false,
      czType:'-1',
      tetle: '新增假期配置',
      // 总条数
      total: null,
      // 每页条数
      pageSizes: 10,
      // 当前页
      nowpage: 1,
      tableData: [],
      gajg: [],
      xzqhTree: [],
      typeList:[
        {
          label: '法定工作日',
          value: '1'
        },
        {
          label: '法定节假日',
          value: '2'
        }
      ],
      // 搜索
      search: {
        type: '',
        cdate: ''
      },
      // 当前选择
      xzqhId: [],
      holidyForm: {
        id: '',
        type: '', // 类型
        cdate: '', // 日期'2022-12-30'格式
        province:'',
        city:'',
        county:'',
        town:'',
      },
      // 校验规则
      rules: {
        type: [{ required: true, message: "请选择",trigger:  ['change'] }],
        cdate: [{ required: true, message: "请选择",trigger:  ['change'] }],
        province: [{ required: true, message: "请选择",trigger:  ['change'] }],
        xzqhId: [
          {
            required: true,
            validator: gajgjiaoyan,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created: function() {
    // 获取列表
    this.getlist()
    //获取行政区划
    xzqhTree().then((e) => {
      this.xzqhTree = [e.data.data]
    })
  },
  methods: {
    // 列表
    getlist() {
      getHolidyList({
        page: this.nowpage,
        size: this.pageSizes,
        param: this.search
      }).then((e)=> {
        this.tableData = e.data.data.rows
        this.total = e.data.data.total
      })
    },
    // 新增-编辑-查看
    addorEdit(type, row) {
      debugger
      this.czType = type
      if (type == '0') {
        // 新增
        this.digshow = !this.digshow
        this.tetle = '新增假期配置'
        this.xzqhId = []
        this.holidyForm = {
          id: '',
          type: '',
          cdate: '',
          province:'',
          city:'',
          county:'',
          town:'',
        }
      } else if (type == '1') {
        // 编辑
        this.digshow = !this.digshow
        this.tetle = '编辑假期配置'
        this.holidyForm = row
        this.xzqhId = []
        if(row.province == '-1'){
          this.xzqhId.push('0')
        }else{
          this.xzqhId.push('0') //全国
          this.xzqhId.push(row.province)
          this.xzqhId.push(row.city)
          this.xzqhId.push(row.county)
        }
        this.xzqhId = this.xzqhId.filter((s) => {
          return s != null && s != ''
        })
        if(this.xzqhId.length > 0){
          this.xzqhId = this.xzqhId.map(Number)
        }
      }
    },
    refreshCache(){
      refreshCache()
          .then(() => {
            this.$message({
              message: '刷新成功！',
              type: 'success'
            })
          })
    },
    delSaveItem(id){ //删除
      this.$confirm('确认删除该项配置?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteSave(id)
            .then((e) => {
              // 重新获取列表
              this.getlist()
              this.$message({
                message: '删除成功！',
                type: 'success'
              })
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 新增/编辑
    saveItem() {
      this.$refs.ruleForm.validate((valid) => {
        if(valid){ //校验通过
          this.$confirm('确认保存吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          }).then((res) => {
              if (this.czType == '0') {
                this.loading = true
                addSave(this.holidyForm).then((res) => {
                  this.loading = false
                  this.getlist()
                  this.digshow = false
                  this.$refs['ruleForm'].clearValidate()
                  this.$message.success('保存成功!')
                }).catch((error) => {
                  this.loading = false
                })
              } else if (this.czType == '1') {
                this.loading = true
              editSave(this.holidyForm).then((res) => {
                this.loading = false
                this.getlist()
                this.digshow = false
                this.$message.success('保存成功!')
              }).catch((error) => {
                this.loading = false
              })
            }
        }).catch((err) => {
          return
        })
        }
      })
    },
    // 关闭窗口
    dialogClose() {
      this.$refs.ruleForm.resetFields()
    },
    jgChange(value) {
      if(value.length == 1 && value[0] == 0){
        this.holidyForm.province = '-1'
      }else if(value.length > 1){
        this.holidyForm.province = value[1] || ''
        this.holidyForm.city = value[2] || ''
        this.holidyForm.county = value[3] || ''
      }
    },
    // 每页条数变换
    sizeChange(val) {
      this.pageSizes = val
      // 重新获取列表
      this.getlist()
    },
    // 翻页
    currentChange(val) {
      this.nowpage = val
      // 重新获取列表
      this.getlist()
    },
    // 重置
    reset() {
      this.search.type = ''
      this.search.cdate = ''
      // 重新获取列表
      this.getlist()
    },
    // 搜索
    searchbtn() {
      // 重新获取列表
      this.getlist()
    },
  }
}
</script>

<style scoped lang="less">
.holidy_pz_box {
  width: 95%;
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  max-width: 1518px;
  .headerSearch {
    max-width: 1518px;

    margin-bottom: 11px;
    margin-top: 30px;
    background-color: white;
    padding: 30px 0 20px 0;
    // border: 1px solid red;
    margin-left: auto;
    margin-right: auto;

    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
}
.t_con_w {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
}
.t_search_form {
  display: flex;
  margin-bottom: 10px;
}
.t_search_form .el-form-item {
  margin-right: 30px;
  margin-bottom: 0;
}
.t_search_btn {
  width: 90px;
  height: 39px;
  background-color: #4170ff;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
/* ------- */
.t_dig {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  max-width: 1200px;
  padding-top: 10px;
}
.t_xkz,
.t_rk {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  padding-top: 40px;
  padding-bottom: 20px;
}
.sousuoButton {
  margin-left: 20px;
  color: #fff;
  background: #4170ff;
  border-color: #4170ff;
}
.el-pagination__total {
  margin-left: 8px;
}
.el-pagination {
  padding: 10px 0;

  border: 1px solid #ebeef5;
  border-top: 0;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
/deep/ .el-table__header-wrapper .el-checkbox {
  //找到表头那一行，然后把里面的复选框隐藏掉
  display: none;
}
</style>
